<template>
  <div class="payment-preview-field mb-4">
    <v-btn
      @click="setDialogInvoicePayment(true)"
      class="white--text mb-2"
      large
      depressed
      color="blue darken-2"
      >{{ $mq | mq({ xs: 'Open Payments', sm: 'Show Payments Popup' }) }}</v-btn
    >
    <!-- <v-text-field
      v-model="total"
      class="mt-4"
      type="number"
      outlined
      label="Preview Order Amount"
      dense
      hide-details
    /> -->
    <DialogInvoicePayment
      :order="{
        id: 'Preview Test Order',
        fields: {
          'Order #': 421,
          'Total Cost': Number(total),
        },
      }"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DialogInvoicePayment from '@/components/DialogInvoicePayment'
export default {
  name: 'PaymentPreviewField',
  components: { DialogInvoicePayment },
  data() {
    return {
      total: 15.0,
    }
  },
  methods: {
    ...mapActions('order', ['setDialogInvoicePayment']),
  },
}
</script>
